import React from 'react'
import MainLayout from '../../components/Layout/MainLayout'
import Loading from '../../components/Loading'
import { Link } from 'react-router-dom'
import { Empty, notification, Table, Space, Badge } from 'antd'
import * as AntdIcon from '@ant-design/icons'
import { LocalStore } from '../../utils/LocalStore'
import { getUrlQueryString } from '../../utils/helper'
import { moneyFormat, parseQueryStringToObject, quantityFormat, updateQueryStringParameter } from '../../utils/stringUtils'
import UserService from '../../services/user.service'
import _, { isArray } from 'lodash'
import lodash from 'lodash'
import { withNamespaces } from 'react-i18next'
import queryString from 'query-string'
import { Row } from 'antd'
import { Col } from 'antd'
import NoData from '../../components/NoData'
import { Divider } from 'antd'
import { Spin } from 'antd'
import { SkeletonTable } from '../../components/SkeletonTable/SkeletonTable'
import moment from 'moment'
import CategoriesService from '../../services/categories.service'

let currentLoggedUser = null
let pageSize = 25
class Lieferscheine extends React.Component {
    constructor(props) {
        super(props)
        this.isUnmounted = false
        this.state = {
            page: 1,
            pageSize: pageSize,
            isLoading: true,
            listLiefercheine: [],
            listChecked: {},
            startTime: undefined,
            endTime: undefined,
            packageCode: '',
            orderCode: '',
            trackingNumber: '',
            typeSearch: '',
            open: '',
            isLoadingDetail: false,
            // isMobile: window.innerWidth < 981,
            // isTablet: window.innerWidth < 1025
        }
    }

    componentDidMount() {
        // Hủy sự kiện cảnh báo khi load trang
        window.onbeforeunload = null
        // window.addEventListener('resize', this.windowResize);
        window.addEventListener('popstate', this.onPopState.bind(this))

        if (typeof LocalStore.getInstance().read('currentLoggedUser') === 'object') {
            currentLoggedUser = LocalStore.getInstance().read('currentLoggedUser')
            this.setState({ isLoading: true }, () => {
                this.loadFromQueryString()
            })
        }
    }

    /**
     * Khi unmount ra thì bỏ sự kiện popstate
     */
    componentWillUnmount() {
        this.isUnmounted = true
        window.removeEventListener('popstate', this.onPopState.bind(this))
        // window.removeEventListener('resize', this.windowResize);
    }

    // /**
    //  * khi window resize
    //  */
    // windowResize = () => {
    //     const windowWidth = window.innerWidth;
    //     if (!this.isUnmounted) this.setState({
    //         isMobile: windowWidth < 981,
    //         isTablet: windowWidth < 1025
    //     })
    // };

    /**
     * On popstate
     */
    onPopState() {
        if (!this.isUnmounted)
            this.setState({ isLoading: true }, () => {
                this.loadFromQueryString()
            })
    }

    /**
     * Load từ QueryString (dành cho lần load đầu tiên)
     */
    loadFromQueryString = () => {
        let queryString = getUrlQueryString()
        let queryObj = parseQueryStringToObject(queryString) || {}

        // console.log('queryObj', queryObj);
        // chuyển giá trị từ queryObj vào state;
        let arrayValue = []
        //reset các param khi load từ url
        let listChecked = {}
        let packageCode = ''
        let trackingNumber = ''
        let orderCode = ''
        let startTime = undefined
        let endTime = undefined
        let handlingTimeFrom = ''
        let handlingTimeTo = ''
        let typeSearch = ''
        let cutOffStatus = ''
        for (let p in queryObj) {
            if (p === 'statuses') {
                // xử lý với obj list checked
                arrayValue = queryObj[p].split(',')
                // console.log('arrayValue', arrayValue)
                listChecked[p] = arrayValue
            } else if (p === 'createdFrom') {
                // xử lý với với timestamp
                startTime = decodeURIComponent(queryObj['createdFrom'])
            } else if (p === 'createdTo') {
                // xử lý với với timestamp
                endTime = decodeURIComponent(queryObj['createdTo'])
            } else if (p === 'handlingTimeFrom' || p === 'handlingTimeTo') {
                // xử lý với với timestamp
                if (p === 'handlingTimeFrom') {
                    handlingTimeFrom = decodeURIComponent(queryObj['handlingTimeFrom'])
                } else {
                    handlingTimeTo = decodeURIComponent(queryObj['handlingTimeTo'])
                }
            } else if (p === 'typeSearch' || p === 'cutOffStatus') {
                // xử lý với với timestamp
                typeSearch = decodeURIComponent(queryObj['typeSearch'])
                cutOffStatus = decodeURIComponent(queryObj['cutOffStatus'])
            } else {
                // xử lý với query
                packageCode = decodeURIComponent(queryObj['packageCode'] || '')
                trackingNumber = decodeURIComponent(queryObj['trackingNumber'] || '')
                orderCode = decodeURIComponent(queryObj['orderCode'] || '')
            }
        }

        this.setState(
            {
                packageCode,
                trackingNumber,
                orderCode,
                startTime,
                endTime,
                listChecked,
                handlingTimeFrom,
                handlingTimeTo,
                typeSearch,
                cutOffStatus,
                page: queryObj.page,
                pageSize: queryObj.size || pageSize,
            },
            () => {
                this.loadData()
            }
        )
    }

    /**
     * load data
     */
    loadData = cb => {
        const { t } = this.props
        const { page, pageSize } = this.state
        let queryString = this.buildQueryString()
        if (queryString) {
            queryString = queryString + `&page=${page ? page - 1 : 0}&size=${pageSize}&sort=createdAt:desc`
        } else {
            queryString = `?page=${page ? page - 1 : 0}&size=${pageSize}&sort=createdAt:desc`
        }
        this.setState({ showProgressBar: true, isLoading: true }, () => {
            UserService.getCustomerLieferscheine(queryString, (err, res, headers) => {
                if (!err) {
                    this.setState(
                        {
                            expandedRow: [],
                            listLiefercheine: res,
                            metadata: {
                                pageCount: headers['x-page-count'],
                                page: headers['x-page-number'],
                                size: headers['x-page-size'],
                                total: headers['x-total-count'],
                            },
                        },
                        () => {
                            //window.scrollTo(0, 0);
                            if (this.mainLayoutElement && this.mainLayoutElement.scrollLayoutElement)
                                this.mainLayoutElement.scrollLayoutElement.scrollTop = 0
                        }
                    )
                } else {
                    notification['error']({
                        message: t(err.message) || t('message.unconnected_error'),
                    })
                }
                if (cb) cb()
                this.setState({ showProgressBar: false, isLoading: false })
            })
        })
    }

    onPageChanged = (page, pageSize) => {
        this.setState({ page: page }, () => {
            let locationQuery = lodash.get(this.props.location, 'search', '')
            let queryObj = locationQuery ? parseQueryStringToObject(locationQuery) : {}
            queryObj.page = page
            queryObj.size = pageSize
            this.props.history.push({
                pathname: this.props.location.pathname,
                search: queryString.stringify(queryObj),
            })
            window.scrollTo(0, 0)
        })
    }

    /**
     * lấy ra danh sách packages
     */
    getPackages = packageCode => {
        this.setState({ isLoadingPackages: true, showProgressBar: true }, () => {
            UserService.getCustomerLieferscheinePackages(packageCode, (err, res, headers) => {
                if (err === null) {
                    this.setState({
                        isLoadingPackages: false,
                        showProgressBar: false,
                        listPackages: res || [],
                    })
                } else {
                    this.setState({ showProgressBar: false, isLoadingPackages: false })
                }
            })
        })
    }

    /**
     * lấy ra danh sách packages
     */
    getDeliveries = packageCode => {
        this.setState({ isLoadingPackages: true, showProgressBar: true }, () => {
            UserService.getCustomerLieferscheineDeliveries(packageCode, (err, res, headers) => {
                if (err === null) {
                    this.setState({
                        isLoadingPackages: false,
                        showProgressBar: false,
                        deliveries: res || [],
                    })
                } else {
                    this.setState({ showProgressBar: false, isLoadingPackages: false })
                }
            })
        })
    }

    /**
     * lấy ra danh sách couries
     */
    getCategoriesCouriers = () => {
        this.setState({ isLoadingPackages: true, showProgressBar: true }, () => {
            CategoriesService.getCouriers((err, res, headers) => {
                if (err === null) {
                    this.setState({
                        isLoadingPackages: false,
                        showProgressBar: false,
                        listcouries: res || [],
                    })
                } else {
                    this.setState({ showProgressBar: false, isLoadingPackages: false })
                }
            })
        })
    }

    /**
     * xây dựng query string theo các giá trị trong state
     * @returns {string}
     */
    buildQueryString = () => {
        let {
            listChecked,
            startTime,
            endTime,
            orderCode,
            packageCode,
            trackingNumber,
            typeSearch,
            cutOffStatus,
            handlingTimeFrom,
            handlingTimeTo,
        } = this.state
        let queryString = ''
        for (let p in listChecked) {
            let value = ''
            if (Array.isArray(listChecked[p]) && listChecked[p].length > 0) {
                listChecked[p].map(x => {
                    value = value + x + ','
                })

                value = value.slice(0, -1)
            }
            if (value) queryString = updateQueryStringParameter(queryString, p, value)
        }

        if (startTime) {
            queryString = updateQueryStringParameter(queryString, 'createdFrom', startTime)
        }

        if (endTime) {
            queryString = updateQueryStringParameter(queryString, 'createdTo', endTime)
        }

        if (orderCode) {
            queryString = updateQueryStringParameter(queryString, 'orderCode', orderCode.trim())
        }

        if (trackingNumber) {
            queryString = updateQueryStringParameter(queryString, 'trackingNumber', trackingNumber.trim())
        }

        if (packageCode) {
            queryString = updateQueryStringParameter(queryString, 'packageCode', packageCode.trim())
        }

        if (handlingTimeFrom || handlingTimeTo) {
            queryString = updateQueryStringParameter(queryString, 'typeSearch', typeSearch)
            queryString = updateQueryStringParameter(queryString, 'cutOffStatus', cutOffStatus)
            if (handlingTimeFrom) {
                queryString = updateQueryStringParameter(queryString, 'handlingTimeFrom', handlingTimeFrom)
            }
            if (handlingTimeTo) {
                queryString = updateQueryStringParameter(queryString, 'handlingTimeTo', handlingTimeTo)
            }
        }

        return queryString
    }

    renderPackages = () => {
        const { t } = this.props
        const { listPackages, isLoadingPackages, deliveries, listcouries } = this.state
        const groupedData = _.groupBy(listPackages, 'orderCode')

        const mergedData = _.map(groupedData, group => {
            return group.reduce(
                (result, item) => {
                    result.packageCode.push(item.packageCode)
                    result.weight.push(item.netWeight)
                    result.allocatedFees = item.allocatedFees
                    result.totalUnpaid = item.totalUnpaid
                    result.isShipment = item.isShipment
                    return result
                },
                {
                    orderCode: group[0].orderCode,
                    packageCode: [],
                    weight: [],
                    allocatedFees: [],
                    totalUnpaid: 0,
                    isShipment: false,
                }
            )
        })

        if (isLoadingPackages)
            return (
                <div className="dpl-flex align-items-center justify-content pdt10 pdbt10">
                    <Spin
                        indicator={
                            <AntdIcon.Loading3QuartersOutlined
                                type="loading"
                                style={{ fontSize: 24 }}
                                spin
                            />
                        }
                    />
                </div>
            )

        const couriersCode = deliveries && _.get(deliveries[0], 'courier', null)
        const nameCouriers = listcouries && listcouries.length > 1 && listcouries.find(item => item.code === couriersCode)?.name

        return (
            <div className="ml-7">
                {listPackages?.length > 0 && !isLoadingPackages && (
                    <Row className=" px-4 py-[6px] rounded-tl-md rounded-tr-md mb-2">
                        <Col span={3}>
                            <div className="robotomedium text-xs text-black-950">{t('lieferscheine.orderCode')}</div>
                        </Col>
                        <Col span={3}>
                            <div className="robotomedium text-xs text-black-950">{t('lieferscheine.packageCode')}</div>
                        </Col>
                        <Col span={3}>
                            <div className="robotomedium text-xs text-black-950">{t('lieferscheine.waybill ')}</div>
                        </Col>
                        <Col span={3}>
                            <div className="robotomedium text-xs text-black-950">{t('lieferscheine.couries')}</div>
                        </Col>
                        <Col span={3}>
                            <div className=" robotomedium text-xs text-black-950">{t('lieferscheine.weight')}</div>
                        </Col>
                        <Col span={5}>
                            <div className=" robotomedium text-xs text-black-950">{t('lieferscheine.allocatedFees')}</div>
                        </Col>
                        <Col span={4}>
                            <div className=" robotomedium text-xs text-black-950">{t('lieferscheine.fee')}</div>
                        </Col>
                    </Row>
                )}

                {!isLoadingPackages && mergedData?.length > 0 ? (
                    mergedData?.map((packge, index) => {
                        const isLastItem = mergedData[mergedData.length - 1] === packge
                        const checkIsShipment = packge?.isShipment
                        return (
                            <div
                                className="w-full px-4"
                                key={index}
                            >
                                <Row className="orderItem py-2">
                                    <Col
                                        span={3}
                                        className="flex items-center"
                                    >
                                        <div className="flex font-medium">
                                            <Link
                                                target="_blank"
                                                to={`/${checkIsShipment ? 'shipments' : 'orders'}/${packge?.orderCode}`}
                                            >
                                                <span className="text-blue-primary font-medium">#{packge?.orderCode} </span>
                                            </Link>
                                        </div>
                                    </Col>
                                    <Col
                                        span={3}
                                        className="flex items-center"
                                    >
                                        <div className="grid gap-2 ">
                                            {packge?.packageCode.map(item => (
                                                <div>{item}</div>
                                            ))}
                                        </div>
                                    </Col>
                                    <Col
                                        span={3}
                                        className="flex items-center"
                                    >
                                        <div className="grid gap-2 ">
                                            {deliveries && deliveries[0]?.trackingNumber ? deliveries[0]?.trackingNumber : '---'}
                                        </div>
                                    </Col>
                                    <Col
                                        span={3}
                                        className="flex items-center"
                                    >
                                        <div className="grid gap-2 ">{nameCouriers ? nameCouriers : '---'}</div>
                                    </Col>
                                    <Col
                                        span={3}
                                        className="flex items-center"
                                    >
                                        <div className="grid gap-2 ">
                                            {packge?.weight.map(item => (
                                                <div> {`${quantityFormat(item)} kg` || '---'}</div>
                                            ))}
                                        </div>
                                    </Col>
                                    <Col
                                        span={5}
                                        className="grid items-center"
                                    >
                                        <div className="grid gap-2">
                                            {packge?.allocatedFees?.length &&
                                                _.sortBy(packge?.allocatedFees, 'amount').map(item => {
                                                    return (
                                                        <div className="flex gap-2 justify-between">
                                                            <span className="font-normal text-sm whitespace-nowrap text-grey-400 basis-6/12">
                                                                {item?.fee?.name}:{' '}
                                                            </span>
                                                            <span className="font-medium text-sm basis-6/12">
                                                                {!item?.fee?.free ? (
                                                                    moneyFormat(item?.amount || 0)
                                                                ) : (
                                                                    <>
                                                                        <span className="line-through text-grey-400 font-light">
                                                                            {moneyFormat(item?.amount || 0)}
                                                                        </span>{' '}
                                                                        <span className='ml-1'>Miễn phí</span>
                                                                    </>
                                                                )}
                                                            </span>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                    </Col>
                                    <Col
                                        span={4}
                                        className="flex items-center"
                                    >
                                        <div className="font-medium text-sm">{moneyFormat(packge?.totalUnpaid)}</div>
                                    </Col>
                                </Row>
                                {!isLastItem ? <Divider style={{ margin: '10px 0px' }} /> : null}
                            </div>
                        )
                    })
                ) : (
                    <div className="block m-auto ">
                        <NoData />
                    </div>
                )}
            </div>
        )
    }

    render() {
        const { listLiefercheine, isLoading, metadata, expandedRow = [] } = this.state
        const { t } = this.props

        const columns = [
            {
                title: t('lieferscheine.code'),
                dataIndex: 'code',
                key: 'code',
                width: '10%',
                render: (text, record) => (
                    <div>
                        <span className="_table-row-code font-medium txt-uppercase text-blue-primary whitespace-pre-wrap">
                            {text}
                        </span>
                    </div>
                ),
            },
            {
                title: t('lieferscheine.totalPackage'),
                dataIndex: 'totalPackage',
                key: 'totalPackage',
                width: '10%',
                className: 'whitespace-pre-wrap text-center',
                render: text => (
                    <span className="_table-row-waybill-code whitespace-pre-wrap ">{text ? text + ' kiện hàng' : '---'}</span>
                ),
            },
            {
                title: <span>{t('lieferscheine.totalAmount')} </span>,
                dataIndex: 'totalUnpaid',
                key: 'totalUnpaid',
                className: 'whitespace-pre-wrap ',
                width: '14%',
                render: (text, row) => (
                    <span className="_table-row-waybill-code whitespace-pre-wrap ">
                        {text !== null ? moneyFormat(text || 0) : '---'}
                    </span>
                ),
            },
            {
                title: t('lieferscheine.totalUnpaid'),
                dataIndex: 'totalAmount',
                key: 'totalAmount',
                width: '10%',
                className: 'whitespace-pre-wrap ',
                render: (text, record) => {
                    return (
                        <span className="_table-row-waybill-code font-roboto font-medium text-black-100 whitespace-pre-wrap ">
                            {text !== null ? moneyFormat(text || 0) : '---'}
                        </span>
                    )
                },
            },
            {
                title: t('lieferscheine.totalWeight'),
                dataIndex: 'totalWeight',
                key: 'totalWeight',
                width: '8%',
                className: 'whitespace-pre-wrap ',
                render: (text, record) => {
                    return (
                        <span className="_table-row-weight">
                            {Number.isFinite(text) ? `${quantityFormat(text)} kg` : t('orderDetail.undefined')}
                        </span>
                    )
                },
            },
            {
                title: t('lieferscheine.issueDate'),
                dataIndex: 'issueDate',
                key: 'issueDate',
                width: '10%',
                className: 'whitespace-nowrap',
                render: (text, record) => {
                    return <span className="_table-row-weight">{text ? moment(text).format('HH:mm DD/MM/YYYY') : '---'}</span>
                },
            },
            {
                title: t('lieferscheine.warehouse'),
                dataIndex: 'address',
                key: 'address',
                width: '40%',
                className: 'whitespace-pre-wrap text-left',
                render: (text, record) => {
                    const recipient = _.get(record.address, 'recipient', '---')
                    const phone = _.get(record.address, 'phone', '---')
                    const location = _.get(record.address, 'location.display', '---')
                    const address1 = _.get(record.address, 'address1', '---')
                    const fullAddress = `${recipient} - ${phone}, ${address1}, ${location}`
                    return <span className="_table-row-waybill-code whitespace-pre-wrap ">{text ? fullAddress : '---'}</span>
                },
            },
        ]

        return (
            <MainLayout
                ref={ref => (this.mainLayoutElement = ref)}
                {...this.props}
                showProgressBar={this.state.showProgressBar}
                headerTitle={t('lieferscheine.title')}
                title={t('lieferscheine.title')}
            >
                <div className={'container-common pdbt30 mgr20'}>
                    {/* {this.renderSearchBox()} */}

                    <div className="pd20 bg-color-white  rounded-xl">
                        <div className="dpl-flex justify-content-between align-items-center v2-layout">
                            {metadata ? (
                                <Space
                                    align="center"
                                    size={2}
                                >
                                    <span className={'txt-color-black txt-size-h5 mr-2 robotobmedium'}>
                                        {t('lieferscheine.title')}
                                    </span>
                                    <Badge count={quantityFormat(metadata.total)} />
                                </Space>
                            ) : (
                                <span />
                            )}
                        </div>
                        {Array.isArray(listLiefercheine) && listLiefercheine.length > 0 ? (
                            <Table
                                ref={ref => (this.table = ref)}
                                className={'table-v2 custom-empty table-expand-row'}
                                rowKey={'code'}
                                rowClassName={(record, index) => index % 2 !== 0 && 'table-row-odd'}
                                onRow={key => {
                                    return expandedRow.includes(key?.code) && { className: 'table-row-expanded' }
                                }}
                                columns={columns}
                                dataSource={listLiefercheine}
                                expandedRowKeys={expandedRow}
                                expandedRowRender={this.renderPackages}
                                expandIcon={expand => {
                                    return (
                                        <i
                                            class={`fa-solid fa-chevron-${
                                                expand.expanded ? 'down' : 'right'
                                            } text-grey-400 cursor-pointer hover:text-black-100`}
                                            onClick={e => expand.onExpand(expand.record, e)}
                                        />
                                    )
                                }}
                                onExpand={(expanded, record) => {
                                    if (expanded) {
                                        this.setState({
                                            expandedRow: [record.code],
                                        })

                                        this.getPackages(record.code)
                                        this.getDeliveries(record.code)
                                        this.getCategoriesCouriers()
                                    } else {
                                        this.setState({
                                            expandedRow: [],
                                        })
                                    }
                                }}
                                locale={{
                                    emptyText: (
                                        <div className="pdt50 pdbt60 bg-color-white">
                                            <Empty
                                                image={require('../../resources/images/empty-image.png')}
                                                description={t('message.empty')}
                                            />
                                        </div>
                                    ),
                                }}
                                pagination={{
                                    className: '_pagination text-center width-100-percent mgt20',
                                    hideOnSinglePage: true,
                                    current: metadata ? parseFloat(metadata.page) + 1 : 1,
                                    total: metadata ? parseFloat(metadata.total) : 1,
                                    pageSize: metadata ? parseFloat(metadata.size) : pageSize,
                                    onChange: (page, pageSize) => this.onPageChanged(page, pageSize),
                                }}
                            />
                        ) : isLoading ? (
                            // <SkeletonTable
                            //     loading={isLoading}
                            //     columns={columns}
                            //     rowCount={25}
                            // ></SkeletonTable>
                            <Loading />
                        ) : (
                            <div className="pdt50 pdbt60 bg-color-white">
                                <Empty
                                    image={require('../../resources/images/empty-image.png')}
                                    description={t('message.empty')}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </MainLayout>
        )
    }
}
export default withNamespaces()(Lieferscheine)
